export class DocumentTemplateManagementConstants {
  public static readonly Add_Template_Button_Tooltip_Message: string =
    'Add Template';
  public static readonly Add_Document_Template_Header_Text: string =
    'Create Document Template';
  public static readonly Edit_Document_Template_Header_Text: string =
    'Edit Document Template';
  public static readonly Update_Document_Template_Header_Text: string =
    'Update Document Template';
  public static readonly Document_Template_File_Max_Size: number = 100;
  public static readonly Document_Template_File_Max_Limit: number = 1;
  public static readonly Document_Template_File_Types: string =
    ".xlsx,.doc,.docx";
  public static readonly Document_Templates_Upload_Folder: string = "eqmsdocumenttemplates";
  public static readonly Document_Template_Save_Progress_Message: string =
    "Document Template Save is in progress";
  public static readonly Document_Template_Update_Progress_Message: string =
    "Document Template Update is in progress";
  public static readonly Severity_Success: string = 'success';
  public static readonly Severity_Err: string = 'error';
  public static readonly Document_Template_Created_Success: string =
    'Document Template Created Successfully';
  public static readonly Document_Template_Updated_Success: string =
    'Document Template Updated Successfully';
    public static readonly Document_Template_Upload_Failed: string =
    'A Technical error occurred and the document template was not uploaded. Please contact technical support team.';
  public static readonly Document_Template_Management: string = 'Document Template';
  public static readonly Document_Template_Management_Scope_PickList_Filter: string = 'name';
  public static readonly Document_Template_Management_Scope_Source_Header: string = 'Available';
  public static readonly Document_Template_Management_Scope_Target_Header: string = 'In Use';
  public static readonly Document_Template_Management_Scope_PickList_Filter_PlaceHolder: string = 'Filter by Keyword';
  public static readonly Document_Template_Management_Scope_Tree_Select_PlaceHolder: string = 'Select Item';
  public static readonly Document_Template_For_Scope_Configuration_Save_Progress_Message: string =
    "Saving Document Templates For Selected Scope is in progress";
  public static readonly Document_Template_For_Scope_Configuration_Loading_Progress_Message: string =
    "Loading Document Templates For Selected Scope is in progress";
  //Error Messages
  public static readonly Document_Template_Error_Message_Header_Text: string =
    'Please correct the following errors to create the Document.';
  public static readonly Document_Template_Unique_Error_Message_Text: string =
    'The Document Template Name must be unique';
  public static readonly Document_Template_File_Required_Error_Message_Text: string =
    'A Document Template file is required.';

  // Confirmation Messages
  public static readonly Document_Template_Management_Confirmation_Header: string =
    'Confirmation';
  public static readonly Document_Template_Slider_Confirmation_Message: string =
    'Any unsaved change will be lost when closing the screen. Do you want to continue?';
  public static readonly Document_Template_DeActivate_Confirmation_Message: string =
    'You are about to deactivate a Document Template. This Document Template will no longer be usable for Documents. This action may impact multiple eQMS Scopes and is not reversible. Do you want to proceed?';

  public static readonly WhereAmIUsed_Empty_Message: string =
    'This Document Template is not used in any eQMS Scope';
}